// extracted by mini-css-extract-plugin
module.exports = {"section":"BottomAction_section__HX8SZ","teaser":"BottomAction_teaser__UfWkL","show":"BottomAction_show__zXdym"};